
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ContactsTable } from "../dashboard/ContactsTable";
import { Spinner } from "@/components/ui/spinner";
import { useToast } from "@/hooks/use-toast";

export const ClientsContainer = () => {
  const { toast } = useToast();
  
  const { data: contacts, isLoading, refetch } = useQuery({
    queryKey: ["contacts"],
    queryFn: async () => {
      console.log("Fetching contacts...");
      
      // Use the user_role_view instead of trying to join tables directly
      const { data, error } = await supabase
        .from('user_role_view')
        .select('user_id, first_name, last_name, email, phone, city, state')
        .eq('role', 'user');

      if (error) {
        console.error("Error fetching contacts:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "Failed to load contacts. Please try again."
        });
        throw error;
      }

      console.log("Contacts fetched:", data);
      
      // Transform the data structure to match what ContactsTable expects
      return data?.map(profile => ({
        id: profile.user_id || '',
        first_name: profile.first_name || '',
        last_name: profile.last_name || '',
        email: profile.email || '',
        phone: profile.phone || '',
        city: profile.city || '',
        state: profile.state || '',
      })) || [];
    },
    refetchOnWindowFocus: true,
    staleTime: 0, // Always fetch fresh data
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <Spinner className="h-8 w-8 text-primary" />
      </div>
    );
  }

  return (
    <div className="p-4">
      <ContactsTable contacts={contacts || []} />
    </div>
  );
};
